import { IBookingStatusModel } from '@services/api/booking-status/booking-status-model.interface';
import { Injectable } from '@angular/core';
import { HardCodedConfigService } from './hard-coded-config.service';

@Injectable({
  providedIn: 'root'
})
export class BookingStatusService {
  constructor(private readonly config: HardCodedConfigService) {}

  getStatusColorClasses(status: IBookingStatusModel | null): string {
    if (!status) {
      return 'bg-gray-100 text-gray-700';
    }
    switch (status.id) {
      case this.config.BOOKING_STATUS_OPEN_ID:
        return 'bg-sky-100 text-sky-700';
      case this.config.BOOKING_STATUS_DATA_SET_ID:
        return 'bg-cyan-100 text-cyan-700';
      case this.config.BOOKING_STATUS_WAITING_FOR_PAYMENT_ID:
        return 'bg-yellow-100 text-yellow-700';
      case this.config.BOOKING_STATUS_CONFIRMABLE_ID:
        return 'bg-blue-100 text-blue-700';
      case this.config.BOOKING_STATUS_FINALIZED_ID:
        return 'bg-green-100 text-green-700';
      case this.config.BOOKING_STATUS_REJECTED_ID:
        return 'bg-red-100 text-red-700';
      default:
        return 'bg-gray-100 text-gray-700';
    }
  }

  /**
   * Get appropriate icon class for booking status
   */
  getStatusIconClasses(status: IBookingStatusModel | null): string {
    if (!status) {
      return 'pi pi-question-circle';
    }
    switch (status.id) {
      case this.config.BOOKING_STATUS_OPEN_ID:
        return 'pi pi-info-circle text-sky-500';
      case this.config.BOOKING_STATUS_DATA_SET_ID:
        return 'pi pi-database text-cyan-500';
      case this.config.BOOKING_STATUS_WAITING_FOR_PAYMENT_ID:
        return 'pi pi-credit-card text-yellow-500';
      case this.config.BOOKING_STATUS_CONFIRMABLE_ID:
        return 'pi pi-check-circle text-blue-500';
      case this.config.BOOKING_STATUS_FINALIZED_ID:
        return 'pi pi-lock text-green-500';
      case this.config.BOOKING_STATUS_REJECTED_ID:
        return 'pi pi-times-circle text-red-500';
      default:
        return 'pi pi-question-circle';
    }
  }
}
